import { SelectedProductInterface } from 'domains/Catalog/Products/components';

export interface ProductsInterface {
  id: number;
  description: string;
  imageUrl?: string;
}

export const getProductsMaped = (
  products: SelectedProductInterface[],
): ProductsInterface[] =>
  products.map((p) => ({
    id: Number(p.id),
    description: p.name,
    imageUrl: p.imageUrl,
  }));

export const getSelectedProductsMaped = (
  products: ProductsInterface[],
): SelectedProductInterface[] =>
  products.map((p) => ({
    id: String(p.id),
    name: p.description,
    imageUrl: p.imageUrl || '',
    stock: false,
    visible: false,
    attributes: [],
    variants: [],
  }));
